import { Box, Image, Skeleton } from '@chakra-ui/react';
import { useContext, useState } from 'react';

import { MasterPlanImageContext } from '../ProjectZonePage';

import ZoneImg from 'img/sun-capital/Master plan/Aurora/Aurora Zone.jpg';
import standAlone from 'img/Zones_SC/Aurora - Stand Alone.svg';
import townHouse from 'img/Zones_SC/Aurora - Twinhouse.svg';
//img/Zones_SC/Aurora - Twinhouse.svg
//img/Zones_SC/Aurora - Townhouse.svg
import twinHouse from 'img/Zones_SC/Aurora - Townhouse.svg';

export default function Img() {
  const [isLoaded, setIsLoaded] = useState(false);

  const { typeName } = useContext(MasterPlanImageContext);

  return (
    <Skeleton
      w="100%"
      h="80%"
      flex={3}
      borderRadius={{ base: '1rem', mobile8: '2rem', tablet16: '3rem' }}
      isLoaded={isLoaded}
    >
      <Box
        position="relative"
        w="100%"
        h="100%"
        borderRadius={{ base: '1rem', mobile8: '2rem', tablet16: '3rem' }}
      >
        <Image
          onLoad={() => setIsLoaded(true)}
          w="100%"
          h="100%"
          borderRadius={{ base: '1rem', mobile8: '2rem', tablet16: '3rem' }}
          objectFit="cover"
          src={selectImage(typeName)}
        />
      </Box>
    </Skeleton>
  );
}

function selectImage(zoneType: string) {
  switch (zoneType) {
    case 'stand-alone':
      return standAlone;
    case 'townhouse':
      return townHouse;
    case 'twin-house':
      return twinHouse;
    default:
      return ZoneImg;
  }
}
